// apps/web/src/components/painel/home/cabecalho-home.tsx — Fase 17.8, Plano 04 (D-10; UI-SPEC U-03).
// Cabeçalho calmo da home: eyebrow com a data longa, `h1` com a saudação e a frase de status montada por regras.
// A frase não usa aria-live (não anuncia cada atualização). O realce é um elemento controlado; o nome do usuário
// entra como texto (React escapa), nunca como HTML.
import type { ReactElement } from 'react';
import type { PerfilHome } from '@pieltec/contracts';
import { saudacaoOperacional } from '../../../lib/dia-operacional';
import type { FraseStatus } from '../../../lib/painel/home/frase';
import { dataLongaCapitalizada } from '../../../lib/painel/home/saudacao';
import '../../../styles/painel-home.css';

export interface CabecalhoHomeProps {
  readonly perfil: PerfilHome;
  /** Primeiro nome já resolvido (`primeiroNome`); vazio omite o nome da saudação. */
  readonly nome: string;
  readonly agora: Date;
  /** Sem frase (sessão sem abas) o parágrafo não é renderizado. */
  readonly frase?: FraseStatus;
}

export function CabecalhoHome({ perfil, nome, agora, frase }: CabecalhoHomeProps): ReactElement {
  return (
    <header className="painel-cabecalho" data-perfil={perfil}>
      <p className="painel-cabecalho__eyebrow painel-entrada painel-entrada-0">{dataLongaCapitalizada(agora)}</p>
      <h1 data-testid="painel-saudacao" className="painel-saudacao painel-entrada painel-entrada-1">
        {saudacaoOperacional(agora)}
        {nome !== '' ? `, ${nome}` : ''}.
      </h1>
      {frase !== undefined && (
        <p data-testid="painel-frase" className="painel-frase painel-entrada painel-entrada-2">
          {frase.antes}
          {frase.realce !== undefined && <span className="realce">{frase.realce}</span>}
          {frase.depois}
        </p>
      )}
    </header>
  );
}
